import styled from 'styled-components';
import { Link } from 'react-router-dom';
import type { CaseRecord } from '@/core/models/case';
import { CategoryBadge } from './CategoryBadge';
import { StatusPill } from './StatusPill';
import { VoteProgressBar } from './VoteProgressBar';
import { useCaseTarget } from '../useCaseTarget';

const Row = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 160px auto;
  gap: 12px;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.glassBorder};
  @media (max-width: 640px) { grid-template-columns: 1fr; }
`;
const Main = styled.div` min-width: 0; `;
const HeadLink = styled(Link)`
  color: ${({ theme }) => theme.color.textPrimary};
  font-weight: 600;
  text-decoration: none;
  &:hover { text-decoration: underline; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.color.focusRing}; outline-offset: 2px; }
`;
const HeadText = styled.span` color: ${({ theme }) => theme.color.textPrimary}; font-weight: 600; `;
const Meta = styled.div`
  margin-top: 4px;
  display: flex; flex-wrap: wrap; row-gap: 8px; column-gap: 0.9em; align-items: center;
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textMuted};
`;

export function CaseRow({ c }: { c: CaseRecord }) {
  const t = useCaseTarget(c);
  return (
    <Row>
      <Main>
        {t.href
          ? <HeadLink to={t.href}>{t.headline}</HeadLink>
          : <HeadText>{t.headline}</HeadText>}
        <Meta>
          <CategoryBadge category={c.category} />
          <span>{c.reporter}</span><span>{c.team}</span><span>{c.time}</span>
        </Meta>
      </Main>
      <VoteProgressBar votes={c.votes} />
      <StatusPill status={c.status} />
    </Row>
  );
}
